import { gql } from '@apollo/client';

export const BlockUserMutationName = 'BlockUser';

export const BLOCK_USER_MUTATION = gql`
  mutation ${BlockUserMutationName}($userId: ID!) {
    blockUser(userId: $userId) {
      userId
      displayName
      blockedAt
    }
  }
`;
